import React from 'react'
import { makeStyles } from '@material-ui/core';
import {HomeWidgetVacio} from '@portal/arq-portal-core';
import { EnlacesFavoritosSeccion } from './EnlacesFavoritosSeccion';
import { EnlacesPersonalesSeccion } from './EnlacesPersonalesSeccion';

const useEstilos = makeStyles(() => ({
    enlacesFavoritosContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        '@media screen and (max-width: 959px)': {
            display: 'block',
        }

    },
    enlacesFavoritosSeccion: {
        padding: '1rem 0',
        flexGrow: 3,
        display: 'flex',
        flexBasis: 0,
        flexWrap: 'wrap',
        '@media screen and (max-width: 1024px)': {
            flexGrow: 2
        },
        '@media screen and (max-width: 959px)': {
            flexGrow: 1
        }
    },
    favoritosVacios: {
        width: '100%',
    },
    enlacesPersonalesSeccion: {
        padding: '1rem 0',
        flexGrow: 1,
        flexBasis: 0
    },
    enlacesFavoritos: {
        minWidth: '33%',
        maxWidth: '33%',
        '@media screen and (max-width: 1024px)': {
            minWidth: '50%',
            maxWidth: '50%'
        },
        '@media screen and (max-width: 767px)': {
            minWidth: '100%',
            maxWidth: '100%'
        }
    }
}));
export interface Data {
    url: string;
    titulo: string;
    plantilla: string,
    tipo: string;
    enlaces: any[]
}
interface Props {
    favoritos: any[];
    personales: any[];
}
export const EnlacesFavoritos = ({ favoritos, personales }: Props): JSX.Element => {
    const clases = useEstilos();

    return (
        <div className={clases.enlacesFavoritosContainer}>
            <div className={clases.enlacesFavoritosSeccion}> 
                {favoritos.length > 0 && favoritos.map((enlace) => (
                    <div className={clases.enlacesFavoritos} key={enlace.id}>
                        <EnlacesFavoritosSeccion item={enlace} />
                    </div>
                ))}
                {!favoritos || favoritos.length == 0 && <div className={clases.favoritosVacios+" widget-content"}><HomeWidgetVacio mensaje="Añade tus favoritos seleccionando la estrella que encontrarás en los puntos de menú."></HomeWidgetVacio></div>}
            </div>
            <div className={clases.enlacesPersonalesSeccion}>
                <EnlacesPersonalesSeccion personales={personales} />
            </div>
        </div>
    )


}

